import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_select, {
      "option-filter-prop": "title",
      mode: _ctx.multiple ? 'multiple' : undefined,
      placeholder: _ctx.placeholder,
      value: _ctx.value,
      "allow-clear": "",
      class: _normalizeClass(["w100", _ctx.class]),
      disabled: _ctx.disabled,
      "show-search": "",
      onChange: _ctx.onChange,
      onClear: _ctx.onClear,
      onSelect: _ctx.onSelect
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
          return (_openBlock(), _createBlock(_component_a_select_option, {
            key: item.id,
            value: item.id,
            title: item.realName,
            disabled: item.disabled
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.realName), 1)
            ]),
            _: 2
          }, 1032, ["value", "title", "disabled"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["mode", "placeholder", "value", "class", "disabled", "onChange", "onClear", "onSelect"])
  ]))
}